import { api } from './api'
import type { SeriesJob } from './series'

export interface DashboardKpis {
  series: { total: number; today: number }
  edits: { total: number; today: number }
  music: { total: number; today: number; duration_sec: number }
  packs: { total: number; today: number; clips: number; stock: number; own: number }
  hooks: { total: number; items: number }
  gems: { balance: number; plan_allowance: number }
}

export interface DashboardQueueItem {
  id: string
  title: string | null
  created_at: string
  status: 'queued' | 'running'
  progress: number
  counts: { total: number; done: number; failed: number; rendering: number; queued: number }
  completed_chunks: number | null
  total_chunks: number | null
}

export interface DashboardMusicAttention {
  id: number
  filename: string
  transcript: string
  transcript_reason: string | null
  transcript_auto_retry: boolean
  beats_status: string
  words: number | null
  signal: 'analysis_file' | 'analysis_auto' | 'analysis_manual' | 'analysis_pending' | 'analysis_beats' | 'instrumental'
}

export interface DashboardActivity {
  kind: 'series_started' | 'series_completed' | 'music_uploaded' | 'pack_created' | 'hook_created'
  at: string
  id: string
  title: string | null
  count?: number
  total?: number
  duration_sec?: number
}

export interface DashboardSnapshot {
  kpis: DashboardKpis
  queue: DashboardQueueItem[]
  now_counts: { running: number; queued: number; failed_24h: number }
  recent: SeriesJob[]
  failed_24h: SeriesJob[]
  music_attention: DashboardMusicAttention[]
  activity: DashboardActivity[]
  billing_available: boolean
  retention_days: number
  last_series_id: string | null
  /** Nieprzeczytane powiadomienia konta — kropka dzwonka (PW); brak pola = 0. */
  notifications_unread?: number
}

export const fetchDashboard = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  return api<DashboardSnapshot>(`/api/dashboard?tz=${encodeURIComponent(tz)}`)
}
